import gql from 'graphql-tag';

const query = gql`
  mutation removeSlot($timeSlotId: ID!) {
    removeSlot(timeSlotId: $timeSlotId)
  }
`;

export default query;
